import React from 'react';
import { motion } from 'framer-motion';
import './Specifications.css';

const Specifications = () => {
  const specsData = [
    {
      title: "Structure & Brickwork",
      points: [
        "Earthquake-resistant R.C.C. structure",
        "Aesthetically designed elevation",
        "Walls constructed with AAC blocks for superior insulation"
      ]
    },
    {
      title: "Plaster & Painting",
      points: [
        "Internal Walls: Gypsum finish over cement-sand plaster",
        "External Walls: Two-coat sand-faced cement plaster",
        "Internal: Roller-finish Tractor Emulsion",
        "External: Weather Shield Acrylic paint"
      ]
    },
    {
      title: "Kitchen & Water Storage",
      points: [
        "Granite platform with stainless steel sink",
        "Glazed dado tiles up to 2 ft. above platform",
        "Overhead & underground water tanks with ample capacity",
        "Provision for water purifier & exhaust fan"
      ]
    },
    {
      title: "Bathrooms & Toilets",
      points: [
        "Glazed dado tiles up to 8 ft. height",
        "Anti-skid ceramic flooring",
        "Jaguar (or equivalent) CP fittings & Sanitary ware",
        "Wall-hung commodes"
      ]
    },
    {
      title: "Electrification",
      points: [
        "Concealed copper wiring (Polycab or equivalent)",
        "Split A/C points in master bedroom & living room",
        "Inverter provision for designated light & fan points",
        "TV & Telephone points in living room"
      ]
    },
    {
      title: "Doors, Windows & Flooring",
      points: [
        "Attractive main door with premium fittings",
        "Powder-coated aluminum sliding windows with mosquito nets",
        "Glazed vitrified tile flooring in all rooms",
        "Anti-skid ceramic flooring in bathrooms & terrace"
      ]
    }
  ];

  return (
    <section id="specifications" className="specs-section">
      <div className="specs-container">
        
        <motion.div 
          className="specs-header"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.2 }}
        >
          <div className="specs-line"></div>
          <h2 className="specs-main-title">Specifications</h2>
          <div className="specs-line"></div>
        </motion.div>

        <div className="specs-grid">
          {specsData.map((spec, index) => (
            <motion.div 
              key={index}
              className="spec-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.1 }}
              transition={{ 
                duration: 0.6, 
                delay: index * 0.1,
                ease: "easeOut" 
              }}
              whileHover={{ y: -10, transition: { duration: 0.2 } }}
            >
              <div className="spec-card-accent"></div>
              <h3 className="spec-card-title">{spec.title}</h3>
              <ul className="spec-points">
                {spec.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specifications;